// This function replaces accents and normalizes and removes spaces with hyphens.
export function sanitizeString(input?: string) {
  if (!input) return null

  const normalized = input?.normalize('NFD')?.replace(/[\u0300-\u036f]/g, '')

  return normalized?.replace(/\s+/g, '-')?.toLowerCase()
}
